export const getRestoItemName = (item = {}) =>
  item.productName || item.name || item.foodItemName || item.details || "";

export const getRestoRateCardName = (item = {}) =>
  item.rateCardName || item.price?.name || "";

export const getRestoItemLabel = (item = {}) => {
  if (item.details) return item.details;
  if (item.foodItemName) return item.foodItemName;

  const productName = getRestoItemName(item);
  const quantityName = item.foodQuantityName || getRestoRateCardName(item);
  return productName && quantityName ? `${productName} (${quantityName})` : productName || quantityName;
};
